<ng-container *ngIf="(mapsLoaderService.mapsApiLoaded$ | async) && googleMapOptions">
  <google-map (idle)="mapIdle($event)" style="height: 100%; width: 100%" [options]="googleMapOptions"
              [ngClass]="{'map-invisible': !mapInitialLoaded || !showMap}" (mapDragend)="mapDragend($event)"
              (zoomChanged)="onZoomChanged($event)" (centerChanged)="googleMapMapCenterChanged()"
              (mapClick)="onMapClicked($event)"
              [width]="width" [height]="height" (mapRightclick)="onMapRightClick($event)"
              (mapInitialized)="handleMapInitialized($event)">

    <ng-container *ngFor="let marker of markers(); trackBy: markerTrackFn">
      <map-marker *ngIf="marker.options()" qpointAfterViewInitTrigger
                  (viewInitialized)="marker.registerGoogleMapsMarkerInstance(markerReference)"
                  [options]="marker.options()"
                  (mapDragend)="markerDragEnd($event, marker)" (mapMouseover)="markerMouseover($event, marker)"
                  (mapMouseout)="markerMouseout($event, marker)" (mapDragstart)="markerDragStart($event, marker)"
                  #markerReference="mapMarker" (mapRightclick)="marker.mapMarkerRightClick.next($event)"
                  (mapClick)="marker.mapClick.next($event);marker.hasInfoWindowTemplate ? marker.openInfoWindow(closeOtherWindowsOnMarkerKlick) : null"
                  (mapMousedown)="markerMouseDown($event, marker)" (mapMouseup)="markerMouseUp()"></map-marker>

    </ng-container>

    <map-info-window #infoWindow="mapInfoWindow" *ngFor="let marker of openMarkerInfoWindows(); trackBy: markerTrackFn"
                     [options]="marker.infoWindowOptions()" qpointAfterViewInitTrigger
                     (viewInitialized)="infoWindow.open(marker.googleMapsMarkerInstance)">
      <div #infoWindowContentReference>
        <div *ngIf="marker?.hasInfoWindowTemplate" class="info-window-header">
          <qpoint-icon class="info-window-close-icon" [icon]="'xmark'"
                       (click)="marker.closeInfoWindow()"></qpoint-icon>
        </div>
        <ng-container *ngTemplateOutlet="marker?.templateRef"></ng-container>
      </div>
    </map-info-window>

    <map-circle *ngFor="let circle of circles" [options]="circle.options"
                (circleClick)="circle.circleClick.next($event)"></map-circle>

    <map-polyline *ngFor="let polyline of polylines(); trackBy: polylineTrackBy"
                  [path]="polyline?.polyline?.coordinates | qpointGeoJsonToGmaps" [options]="polyline.polylineOptions"
                  (polylineRightclick)="setActiveMapPolylineComponent(polyline, $event)"
                  (polylineMousemove)="polyline.polylineMousemove.emit($event)"
                  (polylineMouseout)="polyline.polylineMouseout.emit($event)">
    </map-polyline>

    <map-directions-renderer #directionsRenderer="mapDirectionsRenderer"
                             *ngFor="let direction of directions(); trackBy: directionTrackBy"
                             [directions]="direction.direction()"
                             [options]="direction.options()"
                             (directionsChanged)="direction.handleDirectionChanged(directionsRenderer.getDirections())"></map-directions-renderer>

    <ng-container *ngFor="let polygon of polygons()">
      <ng-container *ngFor="let coordinatesArray of (polygon?.polygon?.coordinates || []); index as i">
        <map-polygon *ngIf="coordinatesArray?.length > 0" [options]="polygon.polygonOptions"
                     [paths]="coordinatesArray | qpointGeoJsonToGmaps" (polygonClick)="polygonClick.emit($event)"
                     (polygonRightclick)="setActiveMapPolygonComponent(polygon, $event, i)"></map-polygon>
      </ng-container>
    </ng-container>
    <ng-container *ngFor="let multiPolygon of multiPolygons()">
      <ng-container *ngFor="let coordinatesArray of (multiPolygon.polygons?.coordinates[0] || []); index as i">
        <map-polygon *ngIf="coordinatesArray?.length > 0" [options]="multiPolygon.polygonOptions" (polygonClick)="polygonClick.emit($event)"
                     [paths]="coordinatesArray | qpointGeoJsonToGmaps"></map-polygon>
      </ng-container>
    </ng-container>
  </google-map>
    <div class="hidden-at-first" #divsToShowPopups *ngFor="let infoWindow of infoWindows; let i = index">
      <ng-container *ngTemplateOutlet="infoWindow?.templateRef"></ng-container>
    </div>
    <ng-container *ngFor="let marker of markers(); let i = index">
      <div qpointMarkerLabelInternal class="hidden-at-first" [markerRef]="marker" *ngIf="marker.labelTemplateRef">
        <ng-container>
          <div class="poi-label poi-label-custom" [style.z-index]="marker.options().zIndex">
            <ng-container *ngTemplateOutlet="marker?.labelTemplateRef"></ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  <div class="map-overlay-footer" *ngIf="mapFooterOverlay">
    <div class="map-overlay-content">
      <ng-container *ngTemplateOutlet="mapFooterOverlay"></ng-container>
    </div>
  </div>
</ng-container>
